import { SVGProps } from 'react';

const Shrub = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 22v-5.172a2 2 0 0 0-.586-1.414L9.5 13.5m5 1L12 17m5-8.2A6 6 0 0 1 13.8 20H10A6.5 6.5 0 0 1 7 8a5 5 0 1 1 10 0z"
    />
  </svg>
);
export default Shrub;
